import React from 'react';
import '../../../../PublicView/Pages/MyMemberships/AuthorizedMembers/AuthorizedMembers.scss';
import { provideIntlService } from '@progress/kendo-react-intl';
import {
    getUserCommittees,
} from '../../../../../Redux/Actions/EndUser/AccountDetailsActions';
import { connect } from 'react-redux';


class CommitteesForm extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            membershipId: this.props.dataItem.membershipId || 0,
            userCommittees: []
        };

    }

    render() {
        return (
            <React.Fragment>
                <div className="account-tab-content">
                    <div>
                        <div>
                            <h1 className="pt-3 pb-3">User Groups/Positions</h1>
                        </div>
                    </div>
                </div>
                { this.props.userCommittees.length > 0 ?
                    <div className="account-tab-content authorized-members">
                        <div className="table-responsive">
                            <div className="row head">
                                <div className="col-lg-3">
                                    <p>Organization Name</p>
                                </div>
                                <div className="col-lg-3">
                                    <p>Position Name</p>
                                </div>
                                <div className="col-lg-3">
                                    <p>Start Date</p>
                                </div>
                                <div className="col-lg-3">
                                    <p>End Date</p>
                                </div>
                            </div>
                            {this.props.userCommittees.map((userCommittee) =>
                                <div className="row">
                                    <div className="col-lg-3">
                                        <p>{userCommittee.committeeName}</p>
                                    </div>
                                    <div className="col-lg-3">
                                        <p>{userCommittee.positionName}</p>
                                    </div>
                                    <div className="col-lg-3">
                                        <p>{provideIntlService(this).formatDate(new Date(userCommittee.begDate), 'MM/d/y')}</p>
                                    </div>
                                    <div className="col-lg-3">
                                        <p>
                                            {provideIntlService(this).formatDate(new Date(userCommittee.endDate), 'MM/d/y')}</p>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div> :
                    <div>
                        <p>The User does not have any groups and positions</p>
                    </div>
                }
                <br />
                <div className="footer">
                    <div className="form-group">
                        <button className="admin-k-button" onClick={this.props.cancel}>
                            <i className="fas fa-times"></i>
                            <span> CANCEL</span>
                        </button>
                    </div>
                </div>
            </React.Fragment>
        );
    }
}

function mapStateToProps(state) {
    return {
        userCommittees: state.accountDetails.userCommittees
    };
}

export default connect(mapStateToProps, { getUserCommittees })(CommitteesForm);

